export const getMaskedNumericValue = (number: string, trailingMask: string): number => {
  const numericValue = number ? Number(String(number).replace(` ${trailingMask}`, '')) : 0;
  return numericValue;
};
